import styled from 'styled-components';

import { SHOW_CARD_WIDTH } from '@utils/constants';
import { DefaultText } from '@components/text';

export const ShowsContainer = styled.div<{ $isEmpty: boolean }>`
  width: 100%;
  height: 100%;
  display: ${({ $isEmpty }) => ($isEmpty ? 'flex' : 'grid')};
  grid-template-columns: repeat(auto-fill, minmax(${SHOW_CARD_WIDTH}px, 1fr));
  gap: 16px;
  padding-inline: 16px;
  padding-bottom: 20px;
  overflow-y: auto;
  justify-content: center;
  ${({ theme }) => theme.scrollbar.default}

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-template-columns: repeat(auto-fit, ${SHOW_CARD_WIDTH}px);
    justify-content: center;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: 1fr;
    padding-inline: 0;
    padding-bottom: 20px;
  }
`;

export const EmptyState = styled(DefaultText)`
  width: 100%;
  text-align: center;
  color: ${({ theme }) => theme.colors.grey[400]};
`;
